import { get, post, put, del } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const assignmentRuleService = {
  /**
   * Get all assignment rules
   */
  getAllRules: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (filters.isActive !== undefined) {
        queryParams.append('isActive', filters.isActive);
      }
      if (filters.status) {
        queryParams.append('status', filters.status);
      }
      if (filters.assignmentType) {
        queryParams.append('assignmentType', filters.assignmentType);
      }
      if (filters.search) {
        queryParams.append('search', filters.search);
      }
      if (filters.priority) {
        queryParams.append('priority', filters.priority);
      }
      if (filters.startDate) {
        queryParams.append('startDate', filters.startDate);
      }
      if (filters.endDate) {
        queryParams.append('endDate', filters.endDate);
      }
      if (filters.createdBy) {
        queryParams.append('createdBy', filters.createdBy);
      }

      const url = queryParams.toString()
        ? `${API_ENDPOINTS.CRM.ASSIGNMENT_RULES}?${queryParams.toString()}`
        : API_ENDPOINTS.CRM.ASSIGNMENT_RULES;

      const response = await get(url);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          rules: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to fetch assignment rules'
        };
      }
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to fetch assignment rules'
      };
    }
  },

  /**
   * Get a single assignment rule by ID
   */
  getRuleById: async (ruleId) => {
    try {
      const response = await get(`${API_ENDPOINTS.CRM.ASSIGNMENT_RULES}/${ruleId}`);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          rule: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to fetch assignment rule'
        };
      }
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to fetch assignment rule'
      };
    }
  },

  /**
   * Create a new assignment rule
   */
  createRule: async (ruleData) => {
    try {
      const response = await post(API_ENDPOINTS.CRM.ASSIGNMENT_RULES, ruleData);

      if (response && response.responseCode === 201) {
        return {
          success: true,
          rule: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to create assignment rule'
        };
      }
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to create assignment rule'
      };
    }
  },

  /**
   * Update an assignment rule
   */
  updateRule: async (ruleId, ruleData) => {
    try {
      const response = await put(`${API_ENDPOINTS.CRM.ASSIGNMENT_RULES}/${ruleId}`, ruleData);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          rule: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to update assignment rule'
        };
      }
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to update assignment rule'
      };
    }
  },

  /**
   * Delete an assignment rule
   */
  deleteRule: async (ruleId) => {
    try {
      const response = await del(`${API_ENDPOINTS.CRM.ASSIGNMENT_RULES}/${ruleId}`);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          rule: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to delete assignment rule'
        };
      }
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to delete assignment rule'
      };
    }
  },

  /**
   * Toggle rule active status
   */
  toggleRuleStatus: async (ruleId) => {
    try {
      const response = await post(`${API_ENDPOINTS.CRM.ASSIGNMENT_RULES}/${ruleId}/toggle`);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          rule: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to toggle rule status'
        };
      }
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to toggle rule status'
      };
    }
  },

  /**
   * Run auto-assignment for all unassigned leads
   */
  runAutoAssignment: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (filters.region) {
        queryParams.append('region', filters.region);
      }
      if (filters.source) {
        queryParams.append('source', filters.source);
      }

      const url = queryParams.toString()
        ? `${API_ENDPOINTS.CRM.ASSIGNMENT_RULES}/run-auto-assignment?${queryParams.toString()}`
        : `${API_ENDPOINTS.CRM.ASSIGNMENT_RULES}/run-auto-assignment`;

      const response = await post(url);

      if (response && response.responseCode === 200) {
        return {
          success: true,
          results: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to run auto-assignment'
        };
      }
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to run auto-assignment'
      };
    }
  },

  /**
   * Manually assign a lead to a user
   */
  manuallyAssignLead: async (leadId, assigneeId, reason = '') => {
    try {
      const response = await post(`${API_ENDPOINTS.CRM.LEADS}/${leadId}/assign`, {
        assigneeId,
        reason
      });

      if (response && response.responseCode === 200) {
        return {
          success: true,
          lead: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to assign lead'
        };
      }
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to assign lead'
      };
    }
  }
};

export default assignmentRuleService;

